export const formatSalesLocationAddress = location => {
  if (!location) return '';

  const parts = [];
  if (location.address) {
    parts.push(location.address);
  }

  const cityStateZip = [location.city, [location.state, location.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  if (cityStateZip) {
    parts.push(cityStateZip);
  }

  return parts.join(', ');
};

export const getSalesLocationTitle = location => {
  const title = location?.location?.trim();
  if (title) return title;
  return formatSalesLocationAddress(location) || 'Unknown location';
};

export const getSalesLocationRegion = location => {
  const region = location?.county?.trim() || location?.name?.trim() || '';
  const title = getSalesLocationTitle(location);
  return region && region !== title ? region : '';
};

export const getSalesLocationSearchText = location => {
  return [
    location?.location,
    location?.name,
    location?.address,
    location?.city,
    location?.state,
    location?.zip,
    location?.county,
    formatSalesLocationAddress(location)
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
};

export const filterSalesLocations = (locations, searchQuery) => {
  const query = searchQuery.trim().toLowerCase();
  if (!query) return locations;

  return locations.filter(location => getSalesLocationSearchText(location).includes(query));
};

export const getSalesLocationIdFromSite = site => site?.salesLocation?._id || site?.salesLocation;

export const buildSitesBySalesLocationId = sites =>
  (sites || []).reduce((sitesByLocation, site) => {
    const salesLocationId = getSalesLocationIdFromSite(site);
    if (!salesLocationId) return sitesByLocation;

    const key = String(salesLocationId);
    if (!sitesByLocation[key]) {
      sitesByLocation[key] = [];
    }
    sitesByLocation[key].push(site);
    return sitesByLocation;
  }, {});

export const buildSiteCountBySalesLocationId = sites => {
  const sitesByLocation = buildSitesBySalesLocationId(sites);
  return Object.keys(sitesByLocation).reduce((counts, key) => {
    counts[key] = sitesByLocation[key].length;
    return counts;
  }, {});
};
